import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import withMobileDialog from "@material-ui/core/withMobileDialog";

import RecordPagination  from "../../utils/RecordsPagination";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  tableStyle: {
    padding: 0
  }
};

const TokenUtilizationTableStructure = ({ classes, records}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell padding="none">Airline</TableCell>
                <TableCell padding="none">Airport</TableCell>
                <TableCell padding="none">Total Passengers</TableCell>
                <TableCell padding="none">Billable Passengers</TableCell>
                {/* <TableCell padding="none">Outstanding Passengers</TableCell> */}
                <TableCell padding="none">PSC Token Utilized</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            { records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell padding="none" className={'text-capitalize'}>
                            {item.Airline}
                        </TableCell>
                        <TableCell padding="none">
                            {item.Airport}
                        </TableCell>
                        <TableCell padding="none">
                            {appHelpers.numberWithCommasOnly(item.TotalPassengers)}
                        </TableCell>
                        <TableCell padding="none">
                            {appHelpers.numberWithCommasOnly(item.BillablePassengers)}
                        </TableCell>
                        {/* <TableCell padding="none">
                            {appHelpers.numberWithCommasOnly(item.OutstandingBillablePassengers)}
                        </TableCell> */}
                        <TableCell padding="none">
                            {appHelpers.numberWithCommasOnly(item.PscTokenUtilized)}
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class TokenUtilizedTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, totalCounts,
        records, currentPage, pageSize, fetchMore } = this.props;
    return (
      <div>
          <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
              <RecordPagination fetchMore={fetchMore} totalCount={totalCounts} pageSize={pageSize} currentPage={currentPage} target={<TokenUtilizationTableStructure classes={classes} records={records}/>}/>
          </div>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(TokenUtilizedTable));



// WEBPACK FOOTER //
// ./src/views/PSCUtilization/TokenUtilizationTable.jsx